import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import "firebase/auth";
let config = {
  apiKey: "AIzaSyADT113rbprwE1IVH4xlJE_ueXGE-Zt9Ik",
  authDomain: "bookmark-anywhere.firebaseapp.com",
  databaseURL: "https://bookmark-anywhere-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "bookmark-anywhere",
  storageBucket: "bookmark-anywhere.appspot.com",
  messagingSenderId: "689052257362",
  appId: "1:689052257362:web:c023e2dae08bc010f3238b",
  measurementId: "G-3CGWPRQZBL"
};


firebase.initializeApp(config);

export default firebase;
